import { Axios } from "../utils/axios.js";

// 报名列表查询
export const tableGet = params => {
  return Axios.get(`/education-member-admin/memberAdmin/signPage`, { params });
};
//报名导出
export const dataExport = () => {
  return Axios.get("/education-member-admin/memberAdmin/signExport", {
    responseType: "arraybuffer"
  });
};



// WEBPACK FOOTER //
// ./src/api/sign.js